var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOuigoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-a",
    d: "M0 0h79.966v79.966H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-c",
    d: "M0 0h79.966v79.966H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-e",
    d: "M0 0h79.966v79.966H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-g",
    d: "M0 0h79.966v79.966H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-i",
    d: "M0 0h79.966v79.966H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-k",
    d: "M0 0h79.966v79.966H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-m",
    d: "M0 0h79.966v79.966H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M79.966 39.983c0 22.082-17.901 39.983-39.983 39.983C17.9 79.966 0 62.065 0 39.983 0 17.9 17.9 0 39.983 0c22.082 0 39.983 17.9 39.983 39.983",
    mask: "url(#mask-b)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M3.561 40.64v-.045c0-4.443 3.548-8.082 8.429-8.082 4.88 0 8.383 3.595 8.383 8.037v.045c0 4.443-3.547 8.082-8.428 8.082S3.56 45.082 3.56 40.64m13.174 0v-.045c0-2.68-1.988-4.912-4.79-4.912S7.2 37.871 7.2 40.55v.045c0 2.679 1.988 4.911 4.79 4.911s4.745-2.187 4.745-4.866",
    mask: "url(#mask-d)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M21.774 41.71v-7.344c0-.96.768-1.719 1.74-1.719.971 0 1.74.76 1.74 1.72v7.255c0 2.545 1.287 3.862 3.411 3.862s3.412-1.272 3.412-3.75v-7.368c0-.96.768-1.719 1.74-1.719s1.74.76 1.74 1.72v7.232c0 4.733-2.689 7.055-6.937 7.055s-6.846-2.344-6.846-6.943",
    mask: "url(#mask-f)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M37.817 34.366c0-.96.768-1.719 1.74-1.719s1.74.76 1.74 1.72v12.457c0 .96-.768 1.719-1.74 1.719s-1.74-.76-1.74-1.72V34.367z",
    mask: "url(#mask-h)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M43.104 40.64v-.045c0-4.443 3.503-8.082 8.293-8.082 2.395 0 3.977.536 5.4 1.518.34.246.724.715.724 1.384 0 .938-.769 1.697-1.718 1.697-.497 0-.813-.178-1.061-.357-.95-.67-1.966-1.072-3.458-1.072-2.53 0-4.541 2.21-4.541 4.867v.045c0 2.857 1.988 4.956 4.79 4.956 1.266 0 2.396-.312 3.277-.938v-2.232h-2.35c-.836 0-1.514-.648-1.514-1.474s.678-1.495 1.514-1.495h3.977c.972 0 1.74.759 1.74 1.719v3.795c0 1.004-.385 1.697-1.22 2.188a10.614 10.614 0 0 1-5.536 1.562c-4.927 0-8.317-3.415-8.317-8.036",
    mask: "url(#mask-j)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M59.374 40.64v-.045c0-4.443 3.547-8.082 8.428-8.082 4.88 0 8.383 3.595 8.383 8.037v.045c0 4.443-3.547 8.082-8.428 8.082-4.88 0-8.383-3.595-8.383-8.037m13.173 0v-.045c0-2.68-1.988-4.912-4.79-4.912s-4.746 2.188-4.746 4.867v.045c0 2.679 1.989 4.911 4.79 4.911 2.803 0 4.746-2.187 4.746-4.866",
    mask: "url(#mask-l)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M41.658 28.496a2.103 2.103 0 1 1-4.205 0 2.103 2.103 0 0 1 4.205 0",
    mask: "url(#mask-n)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuigoLogo);
export default __webpack_public_path__ + "static/media/ouigo-logo.79a0a52f7592b38a8bb14c90bd8bfbe9.svg";
export { ForwardRef as ReactComponent };